module.exports = __webpack_public_path__ + "img/Remove Icon - white.cc1b2711.svg";